import { render } from "./AuthPrefDirect.vue?vue&type=template&id=f45a5908&ts=true"
import script from "./AuthPrefDirect.vue?vue&type=script&lang=ts"
export * from "./AuthPrefDirect.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__